export const FEATURES = [
  'One AI for all your personal data',
  'Gmail integration — inbox zero, automated',
  'Smart memory that never forgets',
  'Instant reports from your data',
  'Real-time web search built in',
  'Scheduled reminders and automations',
  'Photo albums with auto-captions',
  '10GB cloud storage',
]

export function FeatureList() {
  return (
    <ul className="space-y-3">
      {FEATURES.map((feature) => (
        <li key={feature} className="flex items-center gap-3 text-sm text-gray-600">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600">
            <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </span>
          {feature}
        </li>
      ))}
    </ul>
  )
}
